import { gql } from '@apollo/client';

export const GET_ACCOUNT_BIND_DSP = gql`
  query DeliveryQuery {
    dsp: getAccountBindDsp {
      id
      name
      dspCode
      warehouses {
        id
        name
      }
    }
  }
`;

export interface DspWarehouse {
  id: string;
  name: string;
}

export interface GetAccountBindDspResponse {
  dsp: {
    id: string;
    name: string;
    dspCode: string;
    warehouses: DspWarehouse[];
  };
}
